<script>
import { mapGetters } from 'vuex'
import TeamResource from '@/resources/team'

export default {
    name: 'AccountLapTimes',
    computed: {
        ...mapGetters(['userId']),
    },
    data() {
        return {
            hasTeams: false,
        }
    },
    async mounted() {
        const teams = await TeamResource.filterAll({ members: this.userId })
        this.hasTeams = teams.length > 0
    },
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Temps au tour</h4>
            <p class="text-muted mb-0">Analysez vos performances en course et comparez-les à celles des autres.</p>
        </div>
        <b-row>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="stopwatch-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Mes tours</h6>
                            <p class="text-muted small mb-3">Consultez vos temps au tour personnels et l'historique de vos sessions.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'laps' }">Accéder à Mes tours</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="bar-chart-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Classements</h6>
                            <p class="text-muted small mb-3">Découvrez votre classement face aux autres pilotes sur chaque circuit.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'leaderboards' }">Accéder aux classements</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3" v-if="hasTeams">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="people-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Équipes</h6>
                            <p class="text-muted small mb-3">Gérez les équipes avec lesquelles vous participez aux séries à points.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'accountTeams' }">Accéder aux équipes</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
